import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

const TONE = { create: "bg-emerald-50 text-emerald-700", update: "bg-blue-50 text-blue-700", archive: "bg-red-50 text-red-600",
               view: "bg-muted text-muted-foreground", attendance_correction: "bg-purple-50 text-purple-700" };

/** Audit trail scoped to this child: every sensitive change with who, when and why. */
export const HistoryTab = ({ student }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get(`/students/${student.id}/history`).then(({ data }) => setRows(data))
      .catch((e) => toast.error(apiError(e.response?.data?.detail)));
  }, [student.id]);

  if (!rows) return <p className="text-muted-foreground">Loading…</p>;
  return (
    <div className="bg-white rounded-2xl border border-border overflow-x-auto" data-testid="history-tab">
      {rows.length === 0 && <p className="p-6 text-muted-foreground">No recorded changes yet.</p>}
      <table className="w-full text-sm">
        <thead><tr className="border-b border-border text-xs uppercase tracking-wider">{["When", "Who", "Action", "What changed", "Reason"].map((h) => <th key={h} className="text-left p-3 font-bold">{h}</th>)}</tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-b border-border last:border-0" data-testid={`history-${r.id}`}>
              <td className="p-3 whitespace-nowrap text-muted-foreground">{r.at.slice(0, 16).replace("T", " ")}</td>
              <td className="p-3 whitespace-nowrap"><span className="font-bold">{r.user_name}</span><span className="block text-xs text-muted-foreground">{r.role}</span></td>
              <td className="p-3"><span className={`text-xs font-bold px-2.5 py-1 rounded-full ${TONE[r.action] || "bg-amber-50 text-amber-700"}`}>{r.action.replace(/_/g, " ")}</span><span className="block text-xs text-muted-foreground mt-1">{r.resource}</span></td>
              <td className="p-3 max-w-md"><p className="font-semibold">{r.summary}</p>
                {r.before && r.after && typeof r.before === "object" && (
                  <p className="text-xs text-muted-foreground mt-1">{Object.keys(r.after).slice(0, 4).map((k) => `${k}: ${JSON.stringify(r.before?.[k]) ?? "—"} → ${JSON.stringify(r.after[k])}`).join(" · ")}</p>)}</td>
              <td className="p-3 text-muted-foreground max-w-xs">{r.reason}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
